import React from 'react';
import { Flex } from 'antd';
import { CheckSquareOutlined, CloseOutlined } from '@ant-design/icons';
import { Button } from '@bettercomp/ui-components';
import { Plan, SurveySeason } from 'types';
import { PlanStatusBadge } from 'components/SurveyResultsSeason/PlanStatus';

import cn from './styles.module.scss';

type InProgressBannerProps = {
  surveySeason: SurveySeason;
  onContinue?: () => void;
  onClose?: () => void;
};

export function InProgressBanner({ surveySeason, onContinue, onClose }: InProgressBannerProps) {
  return (
    <Flex align="center" gap="middle" className={cn.compactContent}>
      <CheckSquareOutlined />
      <Flex vertical gap={2} className={cn.compactBody}>
        <Flex align="center" gap={10}>
          <span className={cn.planName}>{surveySeason.plan?.name}</span>
          {surveySeason.plan && (
            <PlanStatusBadge plan={surveySeason.plan as Plan} data-testid="surveySeasonDraftBadge" />
          )}
        </Flex>
        <p className={cn.compactDescription}>Pick up where you left off and roll into the new season.</p>
      </Flex>
      <Flex align="center" gap={8}>
        <Button
          type="primary"
          size="large"
          onClick={onContinue}
          data-testid="surveySeasonContinueButton"
          className={cn.ctaButton}
        >
          Continue
        </Button>
        {onClose && (
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            data-testid="surveySeasonCloseButton"
            aria-label="Dismiss"
            className={cn.closeButton}
          />
        )}
      </Flex>
    </Flex>
  );
}
